import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRouteWithRole = ({ children, allowedRoles }) => {
  const { isAuthenticated, userRole, loading, hasAccess, updatePermissionsConfig } = useAuth();
  const location = useLocation();
  const [isUpdatingPermissions, setIsUpdatingPermissions] = useState(false);
  const [permissionsChecked, setPermissionsChecked] = useState(false);
  
  // Efecto para validar permisos al cargar el componente o al cambiar de ruta
  useEffect(() => {
    const validatePermissions = async () => {
      if (isAuthenticated && userRole && !isUpdatingPermissions && !permissionsChecked) {
        try {
          setIsUpdatingPermissions(true);
          // Actualizar permisos al cargar la ruta
          await updatePermissionsConfig();
          console.log(`Permisos validados en ruta: ${location.pathname} para rol: ${userRole}`);
          setPermissionsChecked(true);
        } catch (error) {
          console.error('Error validando permisos:', error);
        } finally {
          setIsUpdatingPermissions(false);
        }
      }
    };
    
    validatePermissions();
  }, [isAuthenticated, userRole, location.pathname, updatePermissionsConfig, isUpdatingPermissions, permissionsChecked]);
  
  // Si está cargando, mostrar un indicador de carga
  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  // Si no está autenticado, redirigir al login
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Si el usuario es admin, siempre tiene acceso
  if (userRole === 'admin') {
    return children;
  }

  // Verificar si el usuario tiene permisos para acceder a esta ruta específica
  if (hasAccess(location.pathname)) {
    return children;
  }

  // Como verificación secundaria, también permitir acceso basado en roles
  if (allowedRoles.includes(userRole)) {
    return children;
  }

  // Si no tiene permisos, redirigir a página de acceso denegado
  return <Navigate to="/access-denied" replace />;
};

export default ProtectedRouteWithRole;